/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */
import { loadImageFromDataUrl } from '@src/common/util/loadImageFromDataUrl';
import { Core } from 'cytoscape';
import html2canvas from 'html2canvas';
import { wait } from '@src/common/util/wait';
import { getFileName } from './getFileName';
import { downloadGraphToast } from './downloadGraphToast';

interface ImgResp {
  success: boolean;
  src: string;
}

export async function downloadGraphImage(
  cy: Core,
  searchValue: string
): Promise<boolean> {
  downloadGraphToast.showImageToast();
  // allow the menu to close and toast to show before the intense processing begins
  await wait(400);
  console.time('get-legend-canvas');
  const legendCanvas = await getLegend();
  console.timeEnd('get-legend-canvas');
  console.time('generate-image');
  const { src, success } = await tryGenerateImageRepeat(cy, legendCanvas);
  console.timeEnd('generate-image');
  downloadGraphToast.hideImageToast();
  if (!success) {
    downloadGraphToast.showImageErrorToast();
    return false;
  }

  const link = document.createElement('a');
  link.setAttribute('href', src);
  link.setAttribute('download', getFileName(searchValue, 'png'));
  link.click();
  return success;
}

async function tryGenerateImageRepeat(
  cy: Core,
  legendCanvas: HTMLCanvasElement
): Promise<ImgResp> {
  let success = false;
  let src = '';
  let tryCount = 0;
  const maxTries = 5;
  while (!success && tryCount < maxTries) {
    tryCount += 1;
    const img = await tryGenerateImage(cy, legendCanvas, tryCount);
    success = img.success;
    src = img.src;
    if (!success) {
      await wait(400);
    }
  }
  return {
    success,
    src,
  };
}

async function tryGenerateImage(
  cy: Core,
  legendCanvas: HTMLCanvasElement,
  tryCount: number
): Promise<ImgResp> {
  const { w, h } = cy.elements().boundingBox();
  try {
    console.time('cy-png');
    const pngDataUrl = cy.png({ full: true });
    console.timeEnd('cy-png');
    console.time('merge-images');
    const src = await toImage(pngDataUrl, legendCanvas);
    console.timeEnd('merge-images');
    console.log(getLogMessage(true, tryCount, w, h));
    return {
      success: true,
      src,
    };
  } catch (e) {
    console.log(getLogMessage(false, tryCount, w, h, e));
    return {
      success: false,
      src: '',
    };
  }
}

async function toImage(
  dataUrl: string,
  canvas: HTMLCanvasElement
): Promise<string> {
  const padding = 10;
  const graphImage = await loadImageFromDataUrl(dataUrl);
  const width = Math.max(graphImage.width, canvas.width) + padding * 2;
  const height = graphImage.height + canvas.height + padding * 2;
  const resultCanvas = document.createElement('canvas');
  resultCanvas.width = width;
  resultCanvas.height = height;
  const ctx = resultCanvas.getContext('2d')!;
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(graphImage, padding, padding);
  ctx.drawImage(canvas, padding, graphImage.height + padding);
  return resultCanvas.toDataURL('img/png');
}

async function getLegend(): Promise<HTMLCanvasElement> {
  return html2canvas(document.querySelector('#linkAnalysisGraphLegend')!, {
    backgroundColor: 'white',
    ignoreElements: (element) =>
      element.tagName === 'canvas' || element.tagName === 'svg',
  });
}

function getLogMessage(
  success: boolean,
  tryCount: number,
  w: number,
  h: number,
  e?: any
) {
  const status = success ? 'succeeded' : 'failed';
  const width = Math.ceil(w);
  const height = Math.ceil(h);
  return `image generation ${status} on attempt number ${tryCount}. {w: ${width}, h: ${height}}. ${
    e || ''
  }`;
}
